import { useTheme } from "@mui/styles";
import Box from "@mui/material/Box";

export default function MuiIndexMarkupWrap({ children }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        margin: "5% 15%",
        "& .youtubeVideo": {
          width: "50% !important",
        },
        [theme.breakpoints.down("md")]: {
          fontSize: "24px",
          margin: "5%",
          overflowX: "scroll",
          "& .youtubeVideo": {
            width: "100% !important",
          },
          "& div": {
            "& table": {
              fontSize: "12px",
            },
          },
        },
        "& h2": {
          color: theme.palette.primary.main,
        },
        "& div": {
          "& table,th,td": {
            border: `1px solid ${theme.palette.primary.main}`,
          },
          "table th,table td": {
            padding: "10px",
          },

          "& thead": {
            backgroundColor: theme.palette.primary.main,
            color: "white !important",
          },
        },
        "& img": {
          maxWidth: "100%",
        },
        "& > iframe": {
          maxWidth: "100%",
        },
      }}
    >
      {children}
    </Box>
  );
}
